import { useTranslation } from "react-i18next";

const ShopSearch = ({ setSearch, etFilterSortParams }) => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t("search_by_name")} </h4>
      <div className="pro-sidebar-search mb-50 mt-25">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="pro-sidebar-search-form"
          action="#"
        >
          <input
            type="text"
            placeholder={`${t("search")} ...`}
            onChange={(e) => setSearch(e.target.value?.toLowerCase())}
          />
          <button>
            <i className="pe-7s-search" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ShopSearch;
